import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null,
    token: '',
    isLoggedIn: false,
    role: null
  }),
  
  actions: {
    setAuth(data) {
      const { token, user } = data
      this.token = token
      this.user = user
      this.isLoggedIn = true
      this.role = user.isAdmin ? 'admin' : 'user'
      
      localStorage.setItem('token', token)
      localStorage.setItem('userInfo', JSON.stringify(user))
      localStorage.setItem('isLoggedIn', 'true')
      localStorage.setItem('role', this.role)
    },
    
    logout() {
      this.user = null
      this.token = ''
      this.isLoggedIn = false
      this.role = null
      
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('role')
    },
    
    loadUser() {
      try {
        const token = localStorage.getItem('token')
        const userInfo = localStorage.getItem('userInfo')
        const isLoggedIn = localStorage.getItem('isLoggedIn')
        const role = localStorage.getItem('role')
        
        if (token && userInfo && isLoggedIn === 'true') {
          this.token = token
          this.user = JSON.parse(userInfo)
          this.isLoggedIn = true
          this.role = role || (this.user?.isAdmin ? 'admin' : 'user')
        }
      } catch (error) {
        console.error('loadUser 解析失败:', error)
        // 清除损坏的数据，避免后续错误
        localStorage.removeItem('userInfo')
        localStorage.removeItem('token')
        localStorage.removeItem('isLoggedIn')
        localStorage.removeItem('role')
        this.isLoggedIn = false
      }
    },
    
    updateToken(newToken) {
      this.token = newToken
      localStorage.setItem('token', newToken)
    }
  },
  
  getters: {
    isAdmin: (state) => state.role === 'admin',
    username: (state) => state.user?.username || '',
    nickname: (state) => state.user?.nickname || '',
    userId: (state) => state.user?.id || null
  }
})